import { MessageSquare, Settings2 } from "lucide-react";

// Agent definitions
export const agents = [
  {
    id: "chat",
    name: "Pricing Assistant",
    description: "Ask questions about pricing strategies & insights",
    icon: MessageSquare,
    color: "#1565C0",
    bgColor: "#E3F2FD",
  },
  {
    id: "rules",
    name: "Rule Builder",
    description: "Create and manage pricing rules",
    icon: Settings2,
    color: "#7B1FA2",
    bgColor: "#F3E5F5",
  },
];
